export default __webpack_public_path__ + "static/media/Equipe5.d1136baa.png";